export function AreArraysEqualShallow(a: any[], b: any[])
{
    return a.length === b.length && a.every((element, index) => element === b[index]);
}

export function FindLastIndex<T>(array: Array<T>, predicate: (value: T, index: number, obj: T[]) => boolean): number {
    let l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
}

export function FindLast<T>(array: Array<T>, predicate: (value: T, index: number, obj: T[]) => boolean): T {
    return array[FindLastIndex(array, predicate)];
}
